// extracted by mini-css-extract-plugin
module.exports = {"title":"App_title__1W9ir","close":"App_close__1FCOP"};